import { useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { CreditCard, Loader2, LogOut, AlertTriangle } from 'lucide-react';

const money = (n) => (n == null ? '' : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`);
const day = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) : '');

export const PaymentPausedScreen = () => {
  const [loading, setLoading] = useState(false);
  const { logout, user } = useAuth();
  const d = user?.payment_declined;

  const openPortal = async () => {
    setLoading(true);
    try {
      // Back from the portal we land on /billing/update-card, which charges the open invoice immediately.
      const res = await api.post('/subscriptions/portal', { origin_url: window.location.origin, return_path: '/billing/update-card?returned=1' });
      window.location.href = res.data.url;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not open billing portal');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="payment-paused-screen">
      <div className="max-w-md w-full text-center">
        <div className="h-16 w-16 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="h-8 w-8 text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-3">Your payment was declined</h1>
        <p className="text-white/50 text-sm leading-relaxed mb-8" data-testid="payment-paused-copy">
          {d ? <>We couldn't charge {money(d.amount)} for your <b className="text-white/75">{d.plan_label}</b> plan{d.declined_at ? ` on ${day(d.declined_at)}` : ''}, so your access is paused. </>
             : <>We couldn't process your last payment, so your account access is paused. </>}
          Update your payment method and we'll re-run the charge right away — access comes back the moment it succeeds.
        </p>
        <button onClick={openPortal} disabled={loading} data-testid="update-payment-btn"
          className="w-full h-12 rounded-xl bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:opacity-90 text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-50">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><CreditCard className="h-4 w-4" /> Update Payment Method</>}
        </button>
        <button onClick={logout} data-testid="paused-logout-btn"
          className="mt-4 text-sm text-white/40 hover:text-white/70 flex items-center gap-1.5 mx-auto">
          <LogOut className="h-3.5 w-3.5" /> Sign out
        </button>
      </div>
    </div>
  );
};
